export default __webpack_public_path__ + "static/media/about-team-steve-chan.be8bc14a.png";